export default __webpack_public_path__ + "static/media/Reposession.0331a9b9.svg";